import type { SearchConversationEnriched } from 'lib-search-types';
import { createContext } from 'react';

export type ConversationRowContextValue = {
  readonly conversation: SearchConversationEnriched;
  /** Whether to show the filter menu item in the row menu. Defaults to true. */
  readonly showRowMenuFilter?: boolean;
};

export const ConversationRowContext =
  createContext<ConversationRowContextValue>(undefined!);
